// @ts-check
if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.headerScroll = function () {
  /**
   * @param Record<string, string>
   * Classes used as CSS styling hooks
   */
  const classes = {
    scrollDowned: "is-scrolled-down",
  };

  /**
   * @param {HTMLElement | null}
   * the <header> element
   */
  const header = document.querySelector(".header");

  /**
   * If the user scrolls past the height of the header then add the active class otherwise remove it
   *
   * @return {void}
   */
  const handleScroll = () => {
    const scrollPoint = document.body.getBoundingClientRect();
    let cutOff = header?.offsetHeight;

    const scrollPosition = scrollPoint.top;
    const scrolledPastHeader = Math.abs(scrollPosition) > cutOff;

    if (scrolledPastHeader) {
      document.documentElement.classList.add(classes.scrollDowned);
    } else {
      document.documentElement.classList.remove(classes.scrollDowned);
    }
  };

  /**
   * Add and remove event listeners that will trigger actions on the elements
   *
   * @returns {void}
   */
  const addEventListeners = () => {
    window.removeEventListener("scroll", handleScroll);
    window.addEventListener("scroll", handleScroll);
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    handleScroll();
    addEventListeners();
  };

  return {
    classes,
    init,
  };
};

window.AndDaughter.headerScroll().init();
